import React, { useContext } from 'react';
import 'twin.macro';
import { AppContext, UserContext } from '../context';
import { Container } from '../container';
import { UnderlinedNav } from '../sections/Header';
import { mainNavList } from '../../data/';

export const MobileFooterMenu = () => {
  const { isDetailPage, windowSize } = useContext(AppContext);
  const { user } = useContext(UserContext);

  return (
    <>
      {!isDetailPage && ['MOBILE'].includes(windowSize.adBreakPoint) && (
        <div
          tw='fixed min-w-[340px] w-full pb-6 bottom-0 z-[32] bg-dark md:hidden'
          className='group text-light'
        >
          <Container noSpacing tw='border-t-[4px] border-input-back'>
            <UnderlinedNav
              itemsList={mainNavList(user)}
              navLocation='footer'
              tw='flex-grow flex-col'
            />
          </Container>
        </div>
      )}
    </>
  );
};
